export default __webpack_public_path__ + "static/media/img-trees.a2cb48bd.jpg";